import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ProductSaveCard from './components/ProductSaveCard';
import BreadCrumb from '../../shared/components/BreadCrumb';

const ProductSave = () => (
  <Container>
    <Row>
      <Col md={12}>
        <BreadCrumb title="Create Product"/>

      </Col>
    </Row>
    <Row>
      <ProductSaveCard />
    </Row>
  </Container>
);

export default ProductSave;
